<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
console.log('test ci..333')
</script>

<style>
/* 非 PC 路由：隐藏横向溢出（滚动条由 reset.css 全站统一隐藏） */
html:not(.pc-viewport-lock),
html:not(.pc-viewport-lock) body {
  overflow-x: hidden;
}
#app {
  min-height: 100%;
  background-color: #3c3068;
  font-family: 'Noto Sans JP', 'Noto Sans', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
